// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment, getMerchant } from '@tectonics/prs/incoming-payment';
import { getName as getMerchantName } from '@tectonics/prs/merchant';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';

type MerchantLogoProps = {|
  height: string,
|};

export function MerchantLogo({ height }: MerchantLogoProps): Node {
  const incomingPayment = useIncomingPayment();
  const merchant = getMerchant(incomingPayment);
  // const logo = getMerchantLogo(merchant);
  const name = getMerchantName(merchant);
  const logo = 'https://s3.sa-east-1.amazonaws.com/assets-staging.ebanx.com/img/merchants/EBX18372DB771.jpg';
  if (logo && logo.trim()) {
    return (
      <Root>
        <Logo height={height} src={logo} alt={name} />
      </Root>
    );
  }

  return (
    <Root>
      <LogoFallbackText>{name}</LogoFallbackText>
    </Root>
  );
}

const Logo = styled.img`
  max-height: ${({ height })=> height ? height : '45px'};
  max-width: 100%;
`;

const Root = styled.div`
  align-self: start;
`;

const LogoFallbackText = styled.h1`
  color: ${theme.colors.secondary(30)};
  font-weight: 600;
  font-size: 1.2em;
  padding: 8px 0 0;
`;
